'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var sha2 = require('multiformats/hashes/sha2');

var base58 = require('multiformats/bases/base58');

var vd = require('varint-decoder');

var varintEncoder = require('../utils/varint-encoder.js');

var index = require('../utils/index.js');

var message = require('./message.js');

var entry = require('./entry.js');

var errcode = require('err-code');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var vd__default = /*#__PURE__*/_interopDefaultLegacy(vd);

var errcode__default = /*#__PURE__*/_interopDefaultLegacy(errcode);

var BitswapMessage = /*#__PURE__*/function (_Symbol$toStringTag) {
  function BitswapMessage(full) {
    _classCallCheck(this, BitswapMessage);

    this.full = full;
    this.wantlist = new Map();
    this.blocks = new Map();
    this.blockPresences = new Map();
    this.pendingBytes = 0;
  }

  _createClass(BitswapMessage, [{
    key: "empty",
    get: function get() {
      return this.blocks.size === 0 && this.wantlist.size === 0 && this.blockPresences.size === 0;
    }
  }, {
    key: "addEntry",
    value: function addEntry(cid, priority, wantType, cancel, sendDontHave) {
      if (wantType == null) {
        wantType = BitswapMessage.WantType.Block;
      }

      var cidStr = cid.toString(base58.base58btc);
      var entry$1 = this.wantlist.get(cidStr);

      if (entry$1) {
        if (entry$1.wantType === wantType) {
          entry$1.priority = priority;
        }

        if (cancel) {
          entry$1.cancel = Boolean(cancel);
        }

        if (sendDontHave) {
          entry$1.sendDontHave = Boolean(sendDontHave);
        }

        if (wantType === BitswapMessage.WantType.Block && entry$1.wantType === BitswapMessage.WantType.Have) {
          entry$1.wantType = wantType;
        }
      } else {
        this.wantlist.set(cidStr, new entry.BitswapMessageEntry(cid, priority, wantType, cancel, sendDontHave));
      }
    }
  }, {
    key: "addBlock",
    value: function addBlock(cid, block) {
      var cidStr = cid.toString(base58.base58btc);
      this.blocks.set(cidStr, block);
    }
  }, {
    key: "addHave",
    value: function addHave(cid) {
      var cidStr = cid.toString(base58.base58btc);

      if (!this.blockPresences.has(cidStr)) {
        this.blockPresences.set(cidStr, BitswapMessage.BlockPresenceType.Have);
      }
    }
  }, {
    key: "addDontHave",
    value: function addDontHave(cid) {
      var cidStr = cid.toString(base58.base58btc);

      if (!this.blockPresences.has(cidStr)) {
        this.blockPresences.set(cidStr, BitswapMessage.BlockPresenceType.DontHave);
      }
    }
  }, {
    key: "cancel",
    value: function cancel(cid) {
      var cidStr = cid.toString(base58.base58btc);
      this.wantlist.delete(cidStr);
      this.addEntry(cid, 0, BitswapMessage.WantType.Block, true, false);
    }
  }, {
    key: "setPendingBytes",
    value: function setPendingBytes(size) {
      this.pendingBytes = size;
    }
  }, {
    key: "serializeToBitswap100",
    value: function serializeToBitswap100() {
      var msg = {
        wantlist: {
          entries: Array.from(this.wantlist.values()).map(function (entry) {
            return {
              block: entry.cid.bytes,
              priority: Number(entry.priority),
              cancel: Boolean(entry.cancel)
            };
          }),
          full: this.full ? true : undefined
        },
        blocks: Array.from(this.blocks.values())
      };
      return message.Message.encode(msg).finish();
    }
  }, {
    key: "serializeToBitswap110",
    value: function serializeToBitswap110() {
      var msg = {
        wantlist: {
          entries: Array.from(this.wantlist.values()).map(function (entry) {
            return {
              block: entry.cid.bytes,
              priority: Number(entry.priority),
              wantType: entry.wantType,
              cancel: Boolean(entry.cancel),
              sendDontHave: Boolean(entry.sendDontHave)
            };
          }),
          full: this.full ? true : undefined
        },
        blockPresences: [],
        payload: [],
        pendingBytes: this.pendingBytes
      };

      var _iterator = _createForOfIteratorHelper(this.blocks.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              cidStr = _step$value[0],
              data = _step$value[1];

          var cid$1 = cid.CID.parse(cidStr);
          var version = cid$1.version;
          var codec = cid$1.code;
          var multihash = cid$1.multihash.code;
          var digestLength = cid$1.multihash.digest.length;
          var prefix = varintEncoder([version, codec, multihash, digestLength]);
          msg.payload.push(new message.Message.Block({
            prefix: prefix,
            data: data
          }));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.blockPresences),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              _cidStr = _step2$value[0],
              bpType = _step2$value[1];

          msg.blockPresences.push(new message.Message.BlockPresence({
            cid: cid.CID.parse(_cidStr).bytes,
            type: bpType
          }));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (this.pendingBytes > 0) {
        msg.pendingBytes = this.pendingBytes;
      }

      return message.Message.encode(msg).finish();
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (this.full !== other.full || this.pendingBytes !== other.pendingBytes || !index.isMapEqual(this.wantlist, other.wantlist) || !index.isMapEqual(this.blocks, other.blocks) || !index.isMapEqual(this.blockPresences, other.blockPresences)) {
        return false;
      }

      return true;
    }
  }, {
    key: _Symbol$toStringTag,
    get: function get() {
      var list = Array.from(this.wantlist.keys());
      var blocks = Array.from(this.blocks.keys());
      return "BitswapMessage <full: ".concat(this.full, ", list: ").concat(list, ", blocks: ").concat(blocks, ">");
    }
  }]);

  return BitswapMessage;
}(Symbol.toStringTag);

BitswapMessage.deserialize = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(raw, hashLoader) {
    var decoded, isFull, msg;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            decoded = message.Message.decode(raw);
            isFull = decoded.wantlist && decoded.wantlist.full || false;
            msg = new BitswapMessage(isFull);

            if (decoded.wantlist && decoded.wantlist.entries) {
              decoded.wantlist.entries.forEach(function (entry) {
                if (!entry.block) {
                  return;
                }

                var cid$1 = cid.CID.decode(entry.block);
                msg.addEntry(cid$1, entry.priority || 0, entry.wantType, Boolean(entry.cancel), Boolean(entry.sendDontHave));
              });
            }

            if (decoded.blockPresences) {
              decoded.blockPresences.forEach(function (blockPresence) {
                if (!blockPresence.cid) {
                  return;
                }

                var cid$1 = cid.CID.decode(blockPresence.cid);

                if (blockPresence.type === BitswapMessage.BlockPresenceType.Have) {
                  msg.addHave(cid$1);
                } else {
                  msg.addDontHave(cid$1);
                }
              });
            }

            if (!(decoded.blocks.length > 0)) {
              _context3.next = 9;
              break;
            }

            _context3.next = 8;
            return Promise.all(decoded.blocks.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(b) {
                var hash, cid$1;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return sha2.sha256.digest(b);

                      case 2:
                        hash = _context.sent;
                        cid$1 = cid.CID.createV0(hash);
                        msg.addBlock(cid$1, b);

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 8:
            return _context3.abrupt("return", msg);

          case 9:
            if (!(decoded.payload.length > 0)) {
              _context3.next = 14;
              break;
            }

            _context3.next = 12;
            return Promise.all(decoded.payload.map( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(p) {
                var values, cidVersion, multicodec, hashAlg, hasher, hash, cid$1;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!(!p.prefix || !p.data)) {
                          _context2.next = 2;
                          break;
                        }

                        return _context2.abrupt("return");

                      case 2:
                        values = vd__default["default"](p.prefix);
                        cidVersion = values[0];
                        multicodec = values[1];
                        hashAlg = values[2];

                        if (!(hashAlg === sha2.sha256.code)) {
                          _context2.next = 10;
                          break;
                        }

                        _context2.t0 = sha2.sha256;
                        _context2.next = 16;
                        break;

                      case 10:
                        _context2.t1 = hashLoader;

                        if (!_context2.t1) {
                          _context2.next = 15;
                          break;
                        }

                        _context2.next = 14;
                        return hashLoader.getHasher(hashAlg);

                      case 14:
                        _context2.t1 = _context2.sent;

                      case 15:
                        _context2.t0 = _context2.t1;

                      case 16:
                        hasher = _context2.t0;

                        if (hasher) {
                          _context2.next = 19;
                          break;
                        }

                        throw errcode__default["default"](new Error('Unknown hash algorithm'), 'ERR_UNKNOWN_HASH_ALG');

                      case 19:
                        _context2.next = 21;
                        return hasher.digest(p.data);

                      case 21:
                        hash = _context2.sent;
                        cid$1 = cid.CID.create(cidVersion, multicodec, hash);
                        msg.addBlock(cid$1, p.data);

                      case 24:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 12:
            msg.setPendingBytes(decoded.pendingBytes);
            return _context3.abrupt("return", msg);

          case 14:
            return _context3.abrupt("return", msg);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

BitswapMessage.blockPresenceSize = function (cid) {
  return cid.bytes.length + 1;
};

BitswapMessage.Entry = entry.BitswapMessageEntry;
BitswapMessage.WantType = {
  Block: message.Message.Wantlist.WantType.Block,
  Have: message.Message.Wantlist.WantType.Have
};
BitswapMessage.BlockPresenceType = {
  Have: message.Message.BlockPresenceType.Have,
  DontHave: message.Message.BlockPresenceType.DontHave
};
exports.BitswapMessage = BitswapMessage;